import type { UseQueryResult } from "@tanstack/react-query";
import { useSelector } from "react-redux";

import {
    selectActiveLeadsType,
    selectActiveSearchResultsDto,
    type LeadsDetailedResultsResponseDto,
    type LeadsSearchRow,
    type BaseLeadsSearchRow,
} from "app/pages/sales-intelligence/modules/leads-search";

import useDomainsDetailedResultsQueryWithDto from "../query/queries/useDomainsDetailedResultsQueryWithDto";

type HookParams<R> = {
    rows?: readonly R[];
    isRowsFetchSuccess: boolean;
};

export function useActiveTabLeadsDetailedResults<R extends BaseLeadsSearchRow = LeadsSearchRow>({
    rows = [],
    isRowsFetchSuccess,
}: HookParams<R>): UseQueryResult<LeadsDetailedResultsResponseDto> {
    const activeLeadsType = useSelector(selectActiveLeadsType);
    const activeSearchResultsDto = useSelector(selectActiveSearchResultsDto);

    const enabled = isRowsFetchSuccess && rows.length > 0;

    return useDomainsDetailedResultsQueryWithDto(
        {
            leadsType: activeLeadsType,
            dto: activeSearchResultsDto,
            rows,
        },
        enabled,
    );
}
